import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-qlower',
    templateUrl: './qlower.component.html',
    styleUrls: ['./qlower.component.scss']
})
export class QlowerComponent {

    constructor(public dialogRef: MatDialogRef<QlowerComponent>) {
    }

    ngOnInit(): void {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
